"use client";
import { KEIConnectProvider } from "./providers";
import { PropsWithChildren, useEffect, useState } from "react";
import { KEIConnectOptions } from "./types";
import { Web3Connect } from "@kei.fi/web3-connect";

export interface KEIConnectProps {
  options: KEIConnectOptions;
}

export const KEIConnect = ({
  children,
  options,
}: PropsWithChildren<KEIConnectProps>) => {
  const [isSSR, setIsSSR] = useState(true);

  useEffect(() => {
    setIsSSR(false);
  }, []);

  if (isSSR) {
    return null;
  }

  return (
    <Web3Connect options={options}>
      <KEIConnectProvider options={options}>{children}</KEIConnectProvider>
    </Web3Connect>
  );
};
